// extracted by css-extract-rspack-plugin
export default {"WidgetLabel":"wCXcn","Footer":"Sm6xV"};